import { FormattedMessage } from "react-intl";
import React, { useEffect, useRef, useState } from "react";
import ImageCard from "./image-card";
import Preview from "./edit-preview-image/preview";
import ImageEditor from "./edit-preview-image/editor";
import Camera from "./camera";
import Toast, { toast, Toaster } from "react-hot-toast";
import "./img-style.css";
import ImageCardDnD from "./image-card";
import { IMedicalImagesVM, IMedicalRecordImagesList, IOrderId } from "../../../../models/response/ISMRResponse";
import { useStore } from "../../../../contexts/store-provider";
import { compressBase64ImageToThumbnail, fileToBase64, MAX_IMAGE_UPLOAD_LIMIT, resizeImage } from "../../../../constants/constants";
import { observer } from "mobx-react";
import { Button } from "react-bootstrap";
import { formatMessage } from "../../../../translations/format-message";
import { ImageTypeEnum } from "../../../../constants/enums/image-type-enum";

interface BeforeAfterProps {
  type: string;
  smrId:number;
  medicalRecordId:number;
  viewOnly:boolean;
  medicalRecordImages: IMedicalImagesVM[];
  medicalRecordTemplate: IMedicalImagesVM[];
}

const BeforeAfter: React.FC<BeforeAfterProps> = ({
  type,
  smrId,
  medicalRecordId,
  viewOnly,
  medicalRecordImages,
  medicalRecordTemplate,
}: BeforeAfterProps) => {
  const {smrStore, headquarterStore, preferencesStore} = useStore()
  const {AddMedicalRecordImagesService, allMedicalRecord, DeleteMedicalRecordImageService, UpdateMedicalRecordOrderIdService,
    UpdateMedicalRecordImageService, GetMedicalRecordImageByImageIdService,
    medicalRecordImageDetail, resetMedicalRecordImageState,setImageUploadLoader,
    updateMedicalRecordImageState
  } = smrStore;
  const {headquarterTemplateDetails} = headquarterStore;
  const [images, setImages] = useState<IMedicalImagesVM[]>(medicalRecordImages);
  const [templateImage, setTemplateImage] = useState<IMedicalImagesVM[]>(medicalRecordTemplate);
  const [showPreview, setShowPreview] = useState(false);
  const [showEditor, setShowEditor] = useState(false);
  const [selectedImage, setSelectedImage] = useState(-3);
  const [selectedImageType, setSelectedImageType] = useState<ImageTypeEnum>(0);
  const [showCamera, setShowCamera] = useState(false);

  useEffect(()=>{
    if(allMedicalRecord.length > 0){
      const selectRecord = allMedicalRecord.filter((record: IMedicalRecordImagesList) => record.MedicalRecordId === medicalRecordId)
      if(selectRecord?.length > 0){
        setImages(type === "Before" ? selectRecord[0]?.ImageBefore : selectRecord[0]?.ImageAfter);
        setTemplateImage(type === "Before" ? selectRecord[0]?.TemplateBefore : selectRecord[0]?.TemplateAfter)
      }
    }
  }, [allMedicalRecord])
  const fileInputRef = useRef<any>(null);

  const triggerCameraCapture = () => {
    if (images.length >= MAX_IMAGE_UPLOAD_LIMIT) {
      toast.error(formatMessage("maximum_10_images_allowed"));
      return;
    }
    setShowCamera(true);
  };

  const handleCameraImage = async (dataUrls: string[]) => {
    try {
      setImageUploadLoader();
      const medicalImagesDetails: any = [];

      for (let i = 0; i < dataUrls.length; i++) {
        const dataUrl = dataUrls[i];
        const base64Image = await compressBase64ImageToThumbnail(dataUrl, 1600, 1600);
        const thumbnailBase64 = await await compressBase64ImageToThumbnail(dataUrl, 200, 200);

        medicalImagesDetails.push({
          ImageType: type === "Before" ? ImageTypeEnum.ImageBefore : ImageTypeEnum.ImageAfter,
          ImageSource: "",
          ImageBase64: base64Image,
          OrderId: images.length + i,
          ThumbnailImage: thumbnailBase64,
        });
      }

      if(medicalImagesDetails?.length > 0)
        AddMedicalRecordImagesService({
          MedicalRecordId: medicalRecordId,
          MedicalImagesDetails: medicalImagesDetails
        }, smrId);
      // setImages((prev: any) => [...prev, ...fileUrls]);
    } catch (error) {
      toast.error(formatMessage("error_processing_images"));
    }
    // try {
    //   const thumbnailBase64 = await compressBase64ImageToThumbnail(dataUrls, 200, 200);
    //   AddMedicalRecordImagesService({
    //     MedicalRecordId: medicalRecordId,
    //     MedicalImagesDetails: [{
    //       ImageType: type === "Before" ? 2 : 3,
    //       ImageSource: "CameraCapture",
    //       ImageBase64: dataUrls,
    //       OrderId: images.length + 1,
    //       ThumbnailImage: thumbnailBase64,
    //     }]
    //   }, smrId);
    // } catch (error) {
    //   toast.error(formatMessage("failed_to_process_camera_image"));
    //   console.error(error);
    // }
  };

const handleImageSelect = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files: File[] = event.target.files ? Array.from(event.target.files) : [];    
    if (files.length + images.length > MAX_IMAGE_UPLOAD_LIMIT) {
      toast.error(formatMessage("upload_up_to_10_images_only"));
      return;
    }
    const validImageFiles = files.filter((file) => file.type.startsWith("image/"));
 
    try {
      setImageUploadLoader();
 
      const medicalImagesDetails: any[] = [];
 
      for (let i = 0; i < validImageFiles.length; i++) {
        const file = validImageFiles[i];
 
        // Convert file to base64 to check size
        const originalBase64 = await fileToBase64(file);
 
        const img = new Image();
        img.src = originalBase64;
        await new Promise((res) => (img.onload = res));
 
        let base64Image: string;
 
        if (img.width > 1600 || img.height > 1600) {
          // Resize only if larger than 1600px
          base64Image = await resizeImage(file, 1600, 1600, 0.5);
        } else {
          // Use original base64 for smaller images
          base64Image = originalBase64;
        }
 
      // Thumbnail always resized
        const thumbnailBase64 = await resizeImage(file, 200, 200, 0.1);
 
        medicalImagesDetails.push({
          ImageType: type === "Before" ? ImageTypeEnum.ImageBefore : ImageTypeEnum.ImageAfter,
          ImageSource: file.name,
          ImageBase64: base64Image,
          OrderId: images.length + i,
          ThumbnailImage: thumbnailBase64,
        });
      }
 
      if(medicalImagesDetails?.length > 0)
        AddMedicalRecordImagesService({
          MedicalRecordId: medicalRecordId,
          MedicalImagesDetails: medicalImagesDetails
        }, smrId);
      // setImages((prev: any) => [...prev, ...fileUrls]);
    } catch (error) {
      toast.error(formatMessage("error_processing_images"));
    }
    event.target.value = ""; // clearing the value after all the action
  };

  const triggerFileSelect = () => {
    if (images.length >= MAX_IMAGE_UPLOAD_LIMIT) {
      toast.error(formatMessage("maximum_10_images_allowed")); 
      return;
    }
    fileInputRef.current.click();
  };

  const handleTemplateUpload = async(event: any) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setImageUploadLoader();
      const base64Image = await resizeImage(file, 1600, 1600, 0.5);
      const thumbnailBase64 = await resizeImage(file, 200, 200, 0.1);
      AddMedicalRecordImagesService({
        MedicalRecordId: medicalRecordId,
        MedicalImagesDetails: [{
          ImageType: type === "Before" ? ImageTypeEnum.TemplateBefore : ImageTypeEnum.TemplateAfter,
          ImageSource: "",
          ImageBase64: base64Image,
          OrderId: 1,
          ThumbnailImage: thumbnailBase64
        }]
      }, smrId);
    } else {
      toast.error(formatMessage("invalid_image_file"));
    }
  };

  const templateInputRef = useRef<any>(null);
  const triggerTemplateUpload = () => {
    templateInputRef.current?.click()
  };

  const handleDeleteImage = (indexToDelete: number) => {
    DeleteMedicalRecordImageService(images[indexToDelete].Id, images[indexToDelete].MedicalRecordId, images[indexToDelete].OrderId, smrId);
  };

  const getImageByIndex = (index:number, imageType: ImageTypeEnum) =>{
    if(index >= 0){
      if(imageType === ImageTypeEnum.TemplateBefore || imageType === ImageTypeEnum.TemplateAfter && templateImage?.length > 0){
        GetMedicalRecordImageByImageIdService(templateImage[index].Id)
      }
      else{
        GetMedicalRecordImageByImageIdService(images[index].Id)
      }
    }
  }
  const handleShowPreview = (index: number, imageType: ImageTypeEnum) => {
    getImageByIndex(index, imageType);
    setSelectedImage(index);
    setSelectedImageType(imageType);
    setShowPreview(true);
  };

  const handleShowEditor = (index: number, imageType: ImageTypeEnum) => {
    getImageByIndex(index, imageType);
    setSelectedImage(index);
    setSelectedImageType(imageType);
    setShowEditor(true);
  };

  const onModalClosed = () => {
    setShowPreview(false);
    setShowEditor(false);
    setShowCamera(false);
    resetMedicalRecordImageState();
    setSelectedImage(-3);
  };

  const moveCard = (from: number, to: number) => {
    let newOrder: IOrderId[] = [];
    const updated = [...images];
    const [moved] = updated.splice(from, 1);
    updated.splice(to, 0, moved);

    // Create the new order array
    newOrder = updated.map((img, index) => ({
      Id: img.Id,
      OrderId: index,
    }));
    UpdateMedicalRecordOrderIdService({MedicalImages: newOrder}, smrId)
  };

  const onEditorSave = async (dataUrl: string) => {
    try {
      const thumbnailBase64 = await compressBase64ImageToThumbnail(dataUrl, 200, 200);
      if(medicalRecordImageDetail){
        if (
            (selectedImageType === ImageTypeEnum.TemplateBefore ||
            selectedImageType === ImageTypeEnum.TemplateAfter) &&
            templateImage?.length > 0
            ) {
          if (templateImage) {
            UpdateMedicalRecordImageService({
              Id: medicalRecordImageDetail.Id,
              MedicalRecordId: medicalRecordImageDetail.MedicalRecordId,
              ImageType: type === "Before" ? ImageTypeEnum.TemplateBefore : ImageTypeEnum.TemplateAfter,
              ImageSource: "",
              ImageBase64: dataUrl,
              ThumbnailImage: thumbnailBase64,
            }, smrId);
          }
        } else {
          UpdateMedicalRecordImageService({
            Id: medicalRecordImageDetail.Id,
            MedicalRecordId: medicalRecordImageDetail.MedicalRecordId,
            ImageType: type === "Before" ? ImageTypeEnum.ImageBefore : ImageTypeEnum.ImageAfter,
            ImageSource: "",
            ImageBase64: dataUrl,
            ThumbnailImage: thumbnailBase64,
          }, smrId);
        }
      }
    } catch (error) {
      console.error("Failed to save edited image:", error);
      toast.error(formatMessage("image_save_error"));
    }finally{
      onModalClosed()
    }
  };


  return (
    <>
      <Toaster />
      {showPreview && (
        <Preview
          image={medicalRecordImageDetail ? medicalRecordImageDetail?.ImageBase64 : ""} 
          onModalClosed={onModalClosed}
        />
      )}
      {showEditor && (
        <ImageEditor
          imageUrl={medicalRecordImageDetail ?
            medicalRecordImageDetail?.ImageBase64 : ""
          }
          key={medicalRecordImageDetail?.ImageBase64 || "editor"}
          onClose={onModalClosed}
          onSave={onEditorSave}
          language={preferencesStore.getLanguage === 'jp' ? 'jp' : 'en'}
        />
      )}
      {showCamera && (
        <Camera onCapture={handleCameraImage} uploadedImagesCount={images.length} onClose={onModalClosed} />
      )}
      <div className="container-row" key={medicalRecordId}>
        <div className="label-wrapper">
          <span className="label-text">
          <FormattedMessage id={type} />
          </span>
        </div>

        <div className="image-scroll-container ">
            {templateImage && templateImage.map((_: any, index: any) => (
              <ImageCard
                type={type}
                key={"template_"+ index}
                id={_?.Id?.toString()}
                index={index}
                viewOnly={viewOnly}
                moveCard={moveCard}
                imageType={type === "Before" ? 0 : 1}
                images={templateImage.map((img)=> {return img.ThumbnailImage})}
                // handleDeleteImage={()=>{}}
                handleShowPreview={handleShowPreview}
                handleShowEditor={handleShowEditor}
              />
            ))}

            {images.map((_: any, index: any) => (
              <ImageCardDnD
                type={type}
                key={index}
                id={_?.Id?.toString()}
                index={index}
                viewOnly={viewOnly}
                moveCard={moveCard}
                imageType={type === "Before" ? 2 : 3}
                images={images.map((img)=> {return img.ThumbnailImage})}
                handleDeleteImage={handleDeleteImage}
                handleShowPreview={handleShowPreview}
                handleShowEditor={handleShowEditor}
              />
            ))}
        </div>
        

        <div className="box-func">
            <input
              type="file"
              accept="image/*"
              multiple
              className="hidden"
              hidden={true}
              ref={fileInputRef}
              disabled={viewOnly}
              onChange={handleImageSelect}
            />
            <Button
              onClick={triggerFileSelect}
              disabled={viewOnly ? viewOnly : (images.length == MAX_IMAGE_UPLOAD_LIMIT)}
              variant="dark"
              className="btn-sm"
            >
              <i className="bi bi-cloud-upload-fill"></i>
            </Button>
            <Button
              onClick={triggerCameraCapture}
              disabled={viewOnly ? viewOnly : (images.length == MAX_IMAGE_UPLOAD_LIMIT)}
              variant="dark"
              className="btn-sm"
            >
              <i className="bi bi-camera-fill"></i>
            </Button>
          </div>
      </div>
    </>
  );
};

export default observer(BeforeAfter);
